import { render, staticRenderFns } from "./filmDistributor.vue?vue&type=template&id=f75e524c&"
import script from "./filmDistributor.vue?vue&type=script&lang=js&"
export * from "./filmDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports